// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__1ed-m","error":"InputSecondary_error__14NHx","disabled":"InputSecondary_disabled__3CAtq"};